import React from 'react';
import { useIntl } from 'react-intl';

import Box from 'carbon-react/lib/components/box';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';

import style from './wizard-loading.scss';

export interface WizardLoadingProps {
  text?: string;
}

export const WizardLoading = ({ text }: WizardLoadingProps) => {
  const intl = useIntl();

  const defaultText = intl.formatMessage({
    id: 'common.loading_please_wait',
    defaultMessage: 'Loading, please wait...'
  });

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
      className={style.container}
    >
      <LoaderSpinner mx="3" spinnerLabel={text || defaultText} variant="action" />
    </Box>
  );
};
